/**
 * Default theme - used when no game-specific theme exists
 */
export const defaultTheme = {
    id: 'default',
    name: 'Default',
    colors: {
        primary: '#8B5CF6', // Violet
        secondary: '#6366F1', // Indigo
        background: '#0F0F1A',
        surface: '#1A1A2E',
        text: '#FFFFFF',
        textMuted: '#9CA3AF',
        accent: '#FBBF24', // Amber
        success: '#22C55E',
        error: '#EF4444',
    },
    gradients: {
        background: 'from-gray-900 via-slate-900 to-gray-900',
        card: 'from-gray-800/50 to-gray-900/50',
    },
};
/**
 * Trivia theme - vibrant purple with gold accents
 */
export const triviaTheme = {
    id: 'trivia',
    name: 'Trivia',
    colors: {
        primary: '#8B5CF6', // Purple
        secondary: '#EC4899', // Pink
        background: '#1F1F3D',
        surface: '#2D2D4A',
        text: '#FFFFFF',
        textMuted: '#A5A5C0',
        accent: '#FBBF24', // Gold for correct
        success: '#22C55E',
        error: '#EF4444',
    },
    gradients: {
        background: 'from-purple-900 via-indigo-900 to-purple-900',
        card: 'from-purple-800/30 to-indigo-900/30',
    },
};
/**
 * Chess theme - classic wood tones
 */
export const chessTheme = {
    id: 'chess',
    name: 'Chess',
    colors: {
        primary: '#92400E', // Warm brown
        secondary: '#78350F', // Dark brown
        background: '#1C1917', // Stone dark
        surface: '#292524', // Stone surface
        text: '#FAFAF9',
        textMuted: '#A8A29E',
        accent: '#F59E0B', // Amber highlights
        success: '#22C55E',
        error: '#EF4444',
    },
    gradients: {
        background: 'from-stone-900 via-amber-950 to-stone-900',
        card: 'from-amber-900/20 to-stone-900/40',
    },
};
/**
 * Texas Hold'em theme - casino green with gold
 */
export const pokerTheme = {
    id: 'texas-holdem',
    name: "Texas Hold'em",
    colors: {
        primary: '#166534', // Casino green
        secondary: '#14532D', // Dark green
        background: '#0F1A0F', // Dark forest
        surface: '#1A2E1A',
        text: '#FFFFFF',
        textMuted: '#86EFAC',
        accent: '#EAB308', // Gold chips
        success: '#22C55E',
        error: '#EF4444',
    },
    gradients: {
        background: 'from-green-950 via-emerald-950 to-green-950',
        card: 'from-green-900/30 to-emerald-950/30',
    },
};
/**
 * Tic-Tac-Toe theme - playful pink/blue
 */
export const ticTacToeTheme = {
    id: 'tic-tac-toe',
    name: 'Tic-Tac-Toe',
    colors: {
        primary: '#EC4899', // Pink
        secondary: '#3B82F6', // Blue
        background: '#1A1A2E',
        surface: '#2D2D4A',
        text: '#FFFFFF',
        textMuted: '#A5A5C0',
        accent: '#FBBF24',
        success: '#22C55E',
        error: '#EF4444',
    },
    gradients: {
        background: 'from-pink-950 via-slate-900 to-blue-950',
        card: 'from-pink-900/20 to-blue-900/20',
    },
};
/**
 * Checkers theme - warm orange/red
 */
export const checkersTheme = {
    id: 'checkers',
    name: 'Checkers',
    colors: {
        primary: '#EA580C', // Orange
        secondary: '#DC2626', // Red
        background: '#1C1917',
        surface: '#292524',
        text: '#FAFAF9',
        textMuted: '#A8A29E',
        accent: '#FBBF24',
        success: '#22C55E',
        error: '#EF4444',
    },
    gradients: {
        background: 'from-orange-950 via-stone-900 to-red-950',
        card: 'from-orange-900/20 to-red-900/20',
    },
};
/**
 * Block Battle theme - neon cyan/indigo
 */
export const blockBattleTheme = {
    id: 'block-battle',
    name: 'Block Battle',
    colors: {
        primary: '#22D3EE',
        secondary: '#3B82F6',
        background: '#0B1020',
        surface: '#0F172A',
        text: '#F8FAFC',
        textMuted: '#94A3B8',
        accent: '#FBBF24',
        success: '#22C55E',
        error: '#EF4444',
    },
    gradients: {
        background: 'from-cyan-950 via-slate-950 to-indigo-950',
        card: 'from-cyan-900/20 to-indigo-900/20',
    },
};
/**
 * All game themes mapped by game type
 */
export const gameThemes = {
    default: defaultTheme,
    trivia: triviaTheme,
    chess: chessTheme,
    'texas-holdem': pokerTheme,
    'tic-tac-toe': ticTacToeTheme,
    checkers: checkersTheme,
    'block-battle': blockBattleTheme,
};
/**
 * Get theme for a game type, falling back to default
 */
export function getGameTheme(gameType) {
    if (!gameType)
        return defaultTheme;
    return gameThemes[gameType] ?? defaultTheme;
}
//# sourceMappingURL=games.js.map